// extracted by mini-css-extract-plugin
export default {"inputContainerUnique":"ArquivamentoSolic_inputContainerUnique__kngxa","descricao":"ArquivamentoSolic_descricao__0h9bx","divPrincipal":"ArquivamentoSolic_divPrincipal__vZkbA"};